import axios from "axios";
import Config from "../../config/";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: {
      Authorization: API_KEY + localStorage.getItem("token")
    }
  };
}

export function deleteEmail(id) {
  const url = `${ROOT_URL}emailmandatory/emailmandatory/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function updateEmail(body) {
  const url = `${ROOT_URL}emailmandatory/emailmandatory/${body.id}/`;

  const fdata = new FormData();
  fdata.append("email", body.email);
  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushEmail(body) {
  const url = `${ROOT_URL}emailmandatory/emailmandatory/`;

  const fdata = new FormData();
  fdata.append("email", body.email);
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchEmail() {
  const url = `${ROOT_URL}emailmandatory/emailmandatory/`;
  const request = axios.get(url, cekAuth());
  return request;
}